<div matDialogContent class="container" fxLayout="column">
  <div fxFill fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxFlex="80" fxLayout="start">
      <p class="mat-title">You've been inactive</p>
    </div>
    <div fxFlex="10" fxLayout="end">
      <mat-icon aria-hidden="false" aria-label="close icon" class="close-icon" mat-dialog-close>close</mat-icon>
    </div>
  </div>
  <div class="bodySectionCls" fxFill fxFlex="100" fxLayout="row" fxLayoutAlign="start center">
    <span class="mat-body-2"
      >You will be logged out in <b style="color: #a32a29">{{ timeToLogout }}s </b></span
    >
  </div>
  <div class="btnSectionCls" fxFill fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="start">
      <button (click)="stayLoggedIn()" color="primary" mat-flat-button>Stay</button>
    </div>
    <div fxLayout="end">
      <button (click)="logoutNow()" color="primary" mat-stroked-button>Logout</button>
    </div>
  </div>
</div>
